var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHot = function SvgIconHot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C29",
    d: "M5.12 9.268v4.09H3.757v3.637H5.12v2.727h1.364v1.364H5.12v.909h12.728v-.91h1.363V18.36h1.818v-7.273h-1.59V9.722h-2.5V6.995h-1.364V4.268H14.21V1.995h-1.363v5h-1.364V3.813H10.12v1.818H8.757v5H6.484V9.268z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M7.393 19.722h1.364v1.818h8.182v-3.182h1.363v-1.363H16.94V15.63h-1.364v-3.636H14.21v2.727h-1.363v-2.273h-1.364v1.364H10.12v1.818H8.757v1.818H7.393z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M14.211 16.995h-2.727v2.727H10.12v1.364h5.455v-2.727H14.21z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FF5C29",
    d: "M6.029 5.631h.909v.909h-.909zM18.757 5.631h.909v2.727h-.909z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F7A600",
    d: "M10.575 8.358h.909v2.727h-.909zM16.939 11.086h.909v.909h-.909z"
  })));
};
export default SvgIconHot;